"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _dateFns = require("date-fns");
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _cccisdClickButton = _interopRequireDefault(require("cccisd-click-button"));
var _cccisdConfirm = _interopRequireDefault(require("cccisd-confirm"));
var _cccisdFormik = require("cccisd-formik");
var _cccisdDatepicker = _interopRequireDefault(require("cccisd-datepicker"));
var _cccisdHiddenBlock = _interopRequireDefault(require("cccisd-hidden-block"));
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } // @1.30.1
var Fortress = window.cccisd.fortress;
var Boilerplate = window.cccisd.boilerplate;
var LicensingForm = function LicensingForm(props) {
  var validLicenseStatus = ['none', 'active', 'expired'];
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isSubmitting = _useState2[0],
    setIsSubmitting = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isAdminExpanded = _useState4[0],
    setIsAdminExpanded = _useState4[1];
  var closeModal = props.closeModal,
    availableLicenseList = props.availableLicenseList,
    row = props.row,
    settings = props.settings;
  var licenseStatus = row.licenseStatus,
    ownedLicenseList = row.ownedLicenseList;
  if (!validLicenseStatus.includes(licenseStatus)) {
    console.error("licenseStatus field returned an invalid value for product");
    return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("p", null, "Error:"), /*#__PURE__*/_react["default"].createElement("p", null, "Invalid license status. Please contact 3C Institute for support at", ' ', /*#__PURE__*/_react["default"].createElement("a", {
      href: "mailto:support@3cisd.com"
    }, "support@3cisd.com"), "."));
  }

  // inherits license from the ancestor group with the most depth
  var _useState5 = (0, _react.useState)(availableLicenseList.length > 0 && availableLicenseList.reduce(function (max, curr) {
      return curr.group.depth > max.group.depth ? curr : max;
    })),
    _useState6 = _slicedToArray(_useState5, 2),
    heldLicense = _useState6[0],
    setHeldLicense = _useState6[1];
  var currentLicense = ownedLicenseList.length > 0 && ownedLicenseList.reduce(function (max, curr) {
    return curr.expiresAt > max.expiresAt ? curr : max;
  });
  var currentExpiration = (0, _dateFns.parse)(currentLicense.expiresAt);
  var cannotSubmit = availableLicenseList.length === 0 || (0, _get2["default"])(heldLicense, 'settings.defaultExpirationSelection') === 'date' && (0, _dateFns.isPast)((0, _dateFns.parse)((0, _get2["default"])(heldLicense, 'settings.defaultExpirationValueDate', '2000-01-01'))) || (0, _get2["default"])(heldLicense, 'settings.defaultExpirationSelection') === 'date' && licenseStatus === 'active' && (0, _dateFns.isAfter)(currentExpiration, (0, _dateFns.parse)((0, _get2["default"])(heldLicense, 'settings.defaultExpirationValueDate', '2199-01-01')));
  function handleSubmit() {
    return _handleSubmit.apply(this, arguments);
  }
  function _handleSubmit() {
    _handleSubmit = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!cannotSubmit) {
              _context2.next = 2;
              break;
            }
            return _context2.abrupt("return");
          case 2:
            (0, _cccisdConfirm["default"])({
              message: 'Are you sure?',
              description: /*#__PURE__*/_react["default"].createElement("span", null, "This will use a license from ", /*#__PURE__*/_react["default"].createElement("b", null, heldLicense.group.group.label), ". This cannot be undone."),
              confirmLabel: 'Submit',
              abortLabel: 'Cancel'
            }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
              var response;
              return _regeneratorRuntime().wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    setIsSubmitting(true);
                    if (!(licenseStatus === 'none')) {
                      _context.next = 7;
                      break;
                    }
                    _context.next = 4;
                    return _cccisdAxios["default"].post(Boilerplate.route('licensing.api.license.create'), {
                      groupId: heldLicense.groupId,
                      pawnId: row['pawn.pawnId'],
                      productId: settings.productId
                    });
                  case 4:
                    response = _context.sent;
                    _context.next = 10;
                    break;
                  case 7:
                    _context.next = 9;
                    return _cccisdAxios["default"].put(Boilerplate.route('licensing.api.license.updateOwned', {
                      license: currentLicense.licenseId
                    }), {
                      action: 'renew',
                      groupId: heldLicense === null || heldLicense === void 0 ? void 0 : heldLicense.groupId
                    });
                  case 9:
                    response = _context.sent;
                  case 10:
                    if (response.data.status === 'error') {
                      (0, _cccisdNotification["default"])({
                        message: 'Failed to update license',
                        data: response.data.errors,
                        duration: 0,
                        type: 'danger'
                      });
                    }
                    setIsSubmitting(false);
                    if (response.data.status === 'success') {
                      closeModal();
                    }
                  case 13:
                  case "end":
                    return _context.stop();
                }
              }, _callee);
            }))).fail(function () {
              closeModal();
            });
          case 3:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return _handleSubmit.apply(this, arguments);
  }
  function handleAdminSubmit(_x) {
    return _handleAdminSubmit.apply(this, arguments);
  }
  function _handleAdminSubmit() {
    _handleAdminSubmit = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(values) {
      var action, expireDate, currentLicenseId, deleteResponse, createResponse, updateResponse;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            action = values.action, expireDate = values.expireDate;
            if (!(!action || ['create', 'update'].includes(action) && !expireDate)) {
              _context3.next = 3;
              break;
            }
            return _context3.abrupt("return");
          case 3:
            setIsSubmitting(true);
            currentLicenseId = currentLicense && currentLicense.licenseId;
            if (!(action === 'delete')) {
              _context3.next = 14;
              break;
            }
            _context3.next = 8;
            return _cccisdAxios["default"]["delete"](Boilerplate.route('licensing.api.license.deleteOwned', {
              license: currentLicenseId
            }));
          case 8:
            deleteResponse = _context3.sent;
            if (deleteResponse.data.status === 'error') {
              (0, _cccisdNotification["default"])({
                message: 'Failed to delete license',
                data: (0, _get2["default"])(deleteResponse, 'data.errors', 'Could not delete license'),
                duration: 0,
                type: 'danger'
              });
            }
            if (deleteResponse.data.status === 'success') {
              (0, _cccisdNotification["default"])({
                message: 'License deleted successfully!',
                type: 'success'
              });
            }
            setIsSubmitting(false);
            closeModal();
            return _context3.abrupt("return");
          case 14:
            if (!(action === 'create')) {
              _context3.next = 27;
              break;
            }
            _context3.next = 17;
            return _cccisdAxios["default"].post(Boilerplate.route('licensing.api.license.create'), {
              groupId: heldLicense ? heldLicense.groupId : null,
              // better to have a groupId, but not necessary
              pawnId: row['pawn.pawnId'],
              productId: settings.productId,
              decrementHeld: false,
              expiration: (0, _dateFns.format)(expireDate, 'YYYY-MM-DD')
            });
          case 17:
            createResponse = _context3.sent;
            currentLicenseId = (0, _get2["default"])(createResponse, 'data.data.id', null);
            if (!(!currentLicenseId || createResponse.data.status === 'error')) {
              _context3.next = 23;
              break;
            }
            (0, _cccisdNotification["default"])({
              message: 'Failed to create license',
              data: (0, _get2["default"])(createResponse, 'data.errors', 'Could not get currentLicenseId'),
              duration: 0,
              type: 'danger'
            });
            setIsSubmitting(false);
            return _context3.abrupt("return");
          case 23:
            if (currentLicenseId && createResponse.data.status === 'success') {
              (0, _cccisdNotification["default"])({
                message: 'License created successfully!',
                type: 'success'
              });
            }
            setIsSubmitting(false);
            closeModal();
            return _context3.abrupt("return");
          case 27:
            if (!(action === 'update')) {
              _context3.next = 35;
              break;
            }
            _context3.next = 30;
            return _cccisdAxios["default"].put(Boilerplate.route('licensing.api.license.updateOwned', {
              license: currentLicenseId
            }), _objectSpread({
              groupId: heldLicense === null || heldLicense === void 0 ? void 0 : heldLicense.groupId,
              expiration: (0, _dateFns.format)(expireDate, 'YYYY-MM-DD'),
              decrementHeld: false
            }, Date.parse(expireDate) < Date.now() ? {
              action: 'expire'
            } : {}));
          case 30:
            updateResponse = _context3.sent;
            if (updateResponse.data.status === 'error') {
              (0, _cccisdNotification["default"])({
                message: 'Failed to update license',
                data: updateResponse.data.errors,
                duration: 0,
                type: 'danger'
              });
            }
            if (updateResponse.data.status === 'success') {
              (0, _cccisdNotification["default"])({
                message: 'License updated successfully!',
                type: 'success'
              });
            }
            setIsSubmitting(false);
            if (updateResponse.data.status === 'success') {
              closeModal();
            }
          case 35:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return _handleAdminSubmit.apply(this, arguments);
  }
  function renderHeadline() {
    var headline;
    switch (licenseStatus) {
      case 'none':
        {
          headline = /*#__PURE__*/_react["default"].createElement("span", null, "No license assigned");
          break;
        }
      case 'active':
        {
          var activeUntil = (0, _dateFns.parse)(currentLicense && currentLicense.expiresAt);
          var daysUntil = (0, _dateFns.differenceInDays)(activeUntil, new Date());
          headline = /*#__PURE__*/_react["default"].createElement("span", null, "License expires ", (0, _dateFns.format)(activeUntil, 'MM/DD/YYYY'), " (", daysUntil, " day", daysUntil === 1 ? '' : 's', ")");
          break;
        }
      case 'expired':
        {
          var expiredDate = (0, _dateFns.parse)(currentLicense && currentLicense.expiresAt);
          var daysAgo = (0, _dateFns.differenceInDays)(new Date(), expiredDate);
          headline = /*#__PURE__*/_react["default"].createElement("span", null, "License expired ", (0, _dateFns.format)(expiredDate, 'MM/DD/YYYY'), " (", daysAgo, " day", daysAgo === 1 ? '' : 's', ' ', "ago)");
          break;
        }
      default:
        console.error("licenseStatus field returned an invalid value for product");
        return null;
    }
    return /*#__PURE__*/_react["default"].createElement("p", {
      className: _style["default"].headline
    }, headline);
  }
  function renderSubmitButton() {
    if (cannotSubmit) {
      return /*#__PURE__*/_react["default"].createElement("span", null);
    }
    var buttonText;
    switch (licenseStatus) {
      case 'none':
        buttonText = 'Start License';
        break;
      case 'active':
        buttonText = 'Extend License';
        break;
      case 'expired':
        buttonText = 'Renew License';
        break;
      default:
        console.error("licenseStatus field returned an invalid value for product");
        return null;
    }
    var button = /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
      isLoading: isSubmitting,
      className: 'btn btn-primary ' + _style["default"].submitButton,
      title: buttonText,
      isDisabled: availableLicenseList.length === 0 || isAdminExpanded,
      type: "button",
      onClick: handleSubmit
    });
    return isAdminExpanded ? /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
      title: "Must close Admin area to use license from ".concat(heldLicense.group.group.label)
    }, button) : button;
  }
  function renderAvailableLicenses() {
    var totalAvailable = availableLicenseList.reduce(function (total, curr) {
      return total + curr.quantity;
    }, 0);
    if (!totalAvailable) {
      switch (licenseStatus) {
        case 'none':
          return /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement("i", null, "No available licenses."));
        case 'active':
          return /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement("i", null, "Cannot extend this license because none are available."));
        case 'expired':
          return /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement("i", null, "Cannot renew this license because none are available."));
        default:
          return /*#__PURE__*/_react["default"].createElement("span", null);
      }
    }
    var actualTotalAvailable = availableLicenseList.reduce(function (total, curr) {
      var currDefaultExpirationSetting = (0, _get2["default"])(curr, 'settings.defaultExpirationSelection', 'duration');
      var currDefaultExpirationDate = (0, _get2["default"])(curr, 'settings.defaultExpirationValueDate', '');
      if (currDefaultExpirationSetting === 'date' && (0, _dateFns.isPast)((0, _dateFns.parse)(currDefaultExpirationDate))) {
        return total;
      }
      return total + curr.quantity;
    }, 0);
    if (!actualTotalAvailable) {
      switch (licenseStatus) {
        case 'none':
          return /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement("i", null, "No available licenses, given the current configuration."));
        case 'active':
          return /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement("i", null, "Cannot extend this license because none are available, given the current configuration."));
        case 'expired':
          return /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement("i", null, "Cannot renew this license because none are available, given the current configuration."));
        default:
          return /*#__PURE__*/_react["default"].createElement("span", null);
      }
    }
    var topContent = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("p", {
      className: _style["default"].totalAvailable
    }, "Total available licenses: ", /*#__PURE__*/_react["default"].createElement("b", null, actualTotalAvailable)), availableLicenseList.length > 1 && /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Formik, {
      initialValues: {
        group: heldLicense.groupId
      }
    }, function (_ref) {
      var setFieldValue = _ref.setFieldValue;
      return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "group",
        component: _cccisdFormik.CccisdSelect,
        label: "Consume license from:",
        options: availableLicenseList.map(function (l) {
          var quantity = l.quantity;
          if ((0, _get2["default"])(l, 'settings.defaultExpirationSelection', 'duration') === 'date') {
            if ((0, _dateFns.isPast)((0, _dateFns.parse)((0, _get2["default"])(l, 'settings.defaultExpirationValueDate', '2000-01-01')))) {
              quantity = 0;
            }
          }
          return {
            value: l.groupId,
            label: "".concat(l.group.group.label, " (").concat(quantity, " available)")
          };
        }),
        onChange: function onChange(e) {
          setFieldValue('group', e.target.value);
          setHeldLicense(availableLicenseList.find(function (l) {
            return l.groupId === Number(e.target.value);
          }));
        }
      });
    }));
    var defaultExpirationSetting = (0, _get2["default"])(heldLicense, 'settings.defaultExpirationSelection', 'duration');
    var defaultExpirationDate = (0, _get2["default"])(heldLicense, 'settings.defaultExpirationValueDate', '');
    var defaultExpirationMonths = (0, _get2["default"])(heldLicense, 'settings.defaultExpirationValueMonths', false);
    var actualExpirationMonths = defaultExpirationMonths || (0, _get2["default"])(heldLicense, 'product.durationMonths', 12);
    var renewMessage = '';

    // NONE
    if (licenseStatus === 'none') {
      if (defaultExpirationSetting === 'date' && (!defaultExpirationDate || (0, _dateFns.isPast)((0, _dateFns.parse)(defaultExpirationDate)))) {
        var _heldLicense$group, _heldLicense$group$gr;
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, topContent, /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement("i", null, /*#__PURE__*/_react["default"].createElement("b", null, (heldLicense === null || heldLicense === void 0 ? void 0 : (_heldLicense$group = heldLicense.group) === null || _heldLicense$group === void 0 ? void 0 : (_heldLicense$group$gr = _heldLicense$group.group) === null || _heldLicense$group$gr === void 0 ? void 0 : _heldLicense$group$gr.label) || 'Group'), " is configured such that this license cannot be started at this time.")));
      }
      if (defaultExpirationSetting === 'date' && defaultExpirationDate) {
        renewMessage = "The user's access will be granted until ".concat((0, _dateFns.format)((0, _dateFns.parse)(defaultExpirationDate), 'MM/DD/YYYY'));
      } else {
        renewMessage = "The license will start now and be available for ".concat(actualExpirationMonths, " months (").concat((0, _dateFns.format)((0, _dateFns.addMonths)(new Date(), actualExpirationMonths), 'MM/DD/YYYY'), ")");
      }
    }

    // ACTIVE
    else if (licenseStatus === 'active') {
      if (defaultExpirationSetting === 'date' && (!defaultExpirationDate || (0, _dateFns.isPast)((0, _dateFns.parse)(defaultExpirationDate)))) {
        var _heldLicense$group2, _heldLicense$group2$g;
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, topContent, /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement("i", null, /*#__PURE__*/_react["default"].createElement("b", null, (heldLicense === null || heldLicense === void 0 ? void 0 : (_heldLicense$group2 = heldLicense.group) === null || _heldLicense$group2 === void 0 ? void 0 : (_heldLicense$group2$g = _heldLicense$group2.group) === null || _heldLicense$group2$g === void 0 ? void 0 : _heldLicense$group2$g.label) || 'Group'), " is configured such that this license cannot be extended at this time.")));
      }
      if (defaultExpirationSetting === 'date' && defaultExpirationDate) {
        // Don't let them take away time
        if ((0, _dateFns.isAfter)(currentExpiration, (0, _dateFns.parse)(defaultExpirationDate))) {
          var _heldLicense$group3, _heldLicense$group3$g;
          return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, topContent, /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement("i", null, actualTotalAvailable <= 0 ? 'This license cannot be extended further.' : "".concat(availableLicenseList.length > 1 ? 'Must change selection to extend this license. ' : 'Cannot extend this license. ', "Expiration for ").concat((heldLicense === null || heldLicense === void 0 ? void 0 : (_heldLicense$group3 = heldLicense.group) === null || _heldLicense$group3 === void 0 ? void 0 : (_heldLicense$group3$g = _heldLicense$group3.group) === null || _heldLicense$group3$g === void 0 ? void 0 : _heldLicense$group3$g.label) || 'Group', " falls before the current expiration for ").concat(row['user.username'] || 'this user', "."))));
        }
        renewMessage = "The user's access will be extended until ".concat((0, _dateFns.format)((0, _dateFns.parse)(defaultExpirationDate), 'MM/DD/YYYY'));
      } else {
        renewMessage = "The user's license will be extended an additional ".concat(actualExpirationMonths, " months (").concat((0, _dateFns.format)((0, _dateFns.addMonths)(currentExpiration, actualExpirationMonths), 'MM/DD/YYYY'), ")");
      }
    }

    // EXPIRED
    else if (licenseStatus === 'expired') {
      if (defaultExpirationSetting === 'date' && (!defaultExpirationDate || (0, _dateFns.isPast)((0, _dateFns.parse)(defaultExpirationDate)))) {
        var _heldLicense$group4, _heldLicense$group4$g;
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, topContent, /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement("i", null, /*#__PURE__*/_react["default"].createElement("b", null, (heldLicense === null || heldLicense === void 0 ? void 0 : (_heldLicense$group4 = heldLicense.group) === null || _heldLicense$group4 === void 0 ? void 0 : (_heldLicense$group4$g = _heldLicense$group4.group) === null || _heldLicense$group4$g === void 0 ? void 0 : _heldLicense$group4$g.label) || 'Group'), " is configured such that this license cannot be renewed at this time.")));
      }
      if (defaultExpirationSetting === 'date' && defaultExpirationDate) {
        renewMessage = "The user's access will be renewed until ".concat((0, _dateFns.format)((0, _dateFns.parse)(defaultExpirationDate), 'MM/DD/YYYY'));
      } else {
        renewMessage = "The user's access will be extended an additional ".concat(actualExpirationMonths, " months (").concat((0, _dateFns.format)((0, _dateFns.addMonths)(new Date(), actualExpirationMonths), 'MM/DD/YYYY'), ")");
      }
    }
    return /*#__PURE__*/_react["default"].createElement("div", null, topContent, /*#__PURE__*/_react["default"].createElement("p", {
      className: _style["default"].licenseExpireDetails
    }, "A license will be used from ", /*#__PURE__*/_react["default"].createElement("b", null, heldLicense.group.group.label), ".\xA0", renewMessage, ". This cannot be undone."));
  }
  function renderAdminArea() {
    var fields = licenseStatus === 'none' ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      type: "radio",
      name: "action",
      value: "create"
    }), "\xA0\xA0Create new license and set expiration to\xA0"), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "expireDate"
    }, function (_ref2) {
      var field = _ref2.field,
        form = _ref2.form;
      return /*#__PURE__*/_react["default"].createElement(_cccisdDatepicker["default"], {
        selected: field.value,
        className: 'form-control-sm ' + _style["default"].datePicker,
        placeholderText: "mm/dd/yyyy",
        onChange: function onChange(date) {
          return form.setFieldValue(field.name, date);
        }
      });
    })) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      type: "radio",
      name: "action",
      value: "update"
    }), "\xA0\xA0Set expiration to\xA0"), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "expireDate"
    }, function (_ref3) {
      var field = _ref3.field,
        form = _ref3.form;
      return /*#__PURE__*/_react["default"].createElement(_cccisdDatepicker["default"], {
        selected: field.value,
        className: 'form-control-sm ' + _style["default"].datePicker,
        placeholderText: "mm/dd/yyyy",
        onChange: function onChange(date) {
          return form.setFieldValue(field.name, date);
        }
      });
    }), currentLicense && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      type: "radio",
      name: "action",
      value: "delete"
    }), "\xA0\xA0Delete license", ' ', currentLicense.activatedDate ? 'activated on ' + (0, _dateFns.format)((0, _dateFns.parse)(currentLicense.activatedDate), 'MM/DD/YYYY') : '')));
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].adminArea
    }, /*#__PURE__*/_react["default"].createElement(_cccisdHiddenBlock["default"], {
      title: "Admin",
      show: isAdminExpanded,
      handleClick: setIsAdminExpanded
    }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Formik, {
      onSubmit: handleAdminSubmit,
      initialValues: {
        action: '',
        expireDate: (0, _dateFns.addMonths)(new Date(), 12)
      }
    }, function (_ref4) {
      var values = _ref4.values,
        onAdvancedSubmit = _ref4.handleSubmit;
      var action = values.action,
        expireDate = values.expireDate;
      var isDisabled = !action || ['create', 'update'].includes(action) && !expireDate;
      var adminButton = /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
        title: "Submit",
        className: "btn btn-warning",
        isLoading: isSubmitting,
        isDisabled: isDisabled,
        onClick: onAdvancedSubmit
      });
      if (isDisabled) {
        adminButton = /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
          title: !action ? 'Make selection' : 'Enter date'
        }, adminButton);
      }
      var note = 'This will not use a license from any group.';
      if (action === 'delete') {
        note = 'This will not add a held license back to any group.';
      } else if (['active', 'expired'].includes(licenseStatus)) {
        note = 'This will not use an additional license from any group.';
      }
      return /*#__PURE__*/_react["default"].createElement("form", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].formUpper
      }, fields), adminButton, action && /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].submitNote
      }, /*#__PURE__*/_react["default"].createElement("i", null, /*#__PURE__*/_react["default"].createElement("small", null, "Note: ", note))));
    })));
  }
  return /*#__PURE__*/_react["default"].createElement("div", null, renderHeadline(), renderAvailableLicenses(), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].btnContainer
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn btn-secondary",
    type: "button",
    onClick: function onClick() {
      return closeModal();
    },
    disabled: isSubmitting
  }, "Close"), renderSubmitButton()), Fortress.hasAnyAccess(['licensing.admin', 'licensing.manage']) && renderAdminArea());
};
var _default = exports["default"] = LicensingForm;